import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { User } from 'src/app/shared/models/user';
import { RoleService } from '../../../../services/user-role.service';
import { UserService } from '../../../../services/user.service';
import { Role } from '../../../../models/user-role';

@Component({
	selector: 'app-my-account',
	templateUrl: './my-account.component.html',
	styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
	public currentUser: User;
	public roleStatus;
	public route = '/admin/account';
	public user = JSON.parse(localStorage.getItem('user'));
	isOwner = false;
	isDropdownOpen = false;
	constructor(
		private el: ElementRef,
		public router: Router,
		private authService: AuthService,
		public userService: UserService,
		private roleService: RoleService
	) {
		this.user = this.authService.getCurrentUser();
		if (this.user) {
			this.currentUser = this.user;
			if (this.currentUser?.roles?.includes('Owner')) {
				this.isOwner = true;
			}
			this.route = 'admin/account';
		} else {
			console.log('NO ');
		}
	}

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUserInfos();
		if (!['Owner', 'Admin', 'SuperAdmin'].includes(this.currentUser.roles[0])) {
			if ((this.currentUser?.userRole?.role as Role)?._id) {
				this.roleStatus = (this.currentUser?.userRole?.role as Role)?.name;
			} else {
				this.roleStatus = this.currentUser.roles[0];
			}
		} else {
			this.roleStatus = this.currentUser.roles[0];
		}
	}

	logoutFunc() {
		this.authService.logout();
	}
	toggleDropdown() {
		this.isDropdownOpen = !this.isDropdownOpen;
	}
	/** 👇 Ferme le dropdown si clic à l’extérieur du composant */
	@HostListener('document:click', ['$event'])
	onClickOutside(event: MouseEvent) {
		if (!this.el.nativeElement.contains(event.target)) {
			this.isDropdownOpen = false;
		}
	}
}
